/** The line under a field whose stored path reads a list by position (Feature 82 D6). */
import { Typography } from '../../ui/finixt.js';
import { hasPosition, POSITION_HINT } from './positions.js';

export function PositionHint({ path }: { path: string | undefined }) {
  if (!path || !hasPosition(path)) return null;
  return (
    <Typography variant="meta" style={{ color: 'var(--danger)' }}>
      {POSITION_HINT}
    </Typography>
  );
}
